import React, { createContext, useContext, useEffect, useRef } from 'react';

type InfoDialogProps = { open: boolean; onClose: () => void; children: React.ReactNode; className?: string };
export type LuxPlusControls = {
  Button: React.ComponentType<React.ButtonHTMLAttributes<HTMLButtonElement>>;
  Input: React.ComponentType<React.InputHTMLAttributes<HTMLInputElement>>;
  Select: React.ComponentType<React.SelectHTMLAttributes<HTMLSelectElement>>;
  Dialog: React.ComponentType<InfoDialogProps>;
};
function HtmlDialog({ open, onClose, children, className }: InfoDialogProps) {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (open) {
      dialog.current?.showModal();
    } else {
      dialog.current?.close();
    }
  }, [open]);
  return (
    <dialog className={className} ref={dialog} onCancel={onClose} aria-labelledby="lp-info-title">
      {children}
    </dialog>
  );
}
export const htmlControls: LuxPlusControls = {
  Button: (props) => <button {...props} />,
  Input: (props) => <input {...props} />,
  Select: (props) => <select {...props} />,
  Dialog: HtmlDialog,
};
export const LuxPlusControlContext = createContext<LuxPlusControls>(htmlControls);
export function ReportButton(props: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const { Button } = useContext(LuxPlusControlContext);
  return <Button {...props} />;
}
export function ReportInput(props: React.InputHTMLAttributes<HTMLInputElement>) {
  const { Input } = useContext(LuxPlusControlContext);
  return <Input {...props} />;
}
export function ReportSelect(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  const { Select } = useContext(LuxPlusControlContext);
  return <Select {...props} />;
}
